import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Autoplay } from "swiper/modules";
import { Box, Typography, Rating, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { get_all_testimonials } from '../../services/testimonialService.js'

export default function TestimonialSlider({ restaurant }) {
  const themeColors = {
    accent: restaurant?.theme_config?.accent_color || '#FF6B35',
    primary: restaurant?.theme_config?.primary_color || '#D4AF37',
    secondary: restaurant?.theme_config?.secondary_color || '#8B4513',
  };

  const [testimonials, setTestimonials] = useState([
    {
      stars: 5,
      title: "Handmade Ice Cream is a Must-Try!",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      customer_name: "Katya Kulpo"
    },
    {
      stars: 5,
      title: "Best Fresh Vegetables in Town!",
      description: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      customer_name: "John Doe"
    },
    {
      stars: 4.5,
      title: "Amazing Quality and Fast Delivery",
      description: "Curabitur pretium tincidunt lacus. Nulla gravida orci a odio. Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus magna felis sollicitudin mauris. Integer in mauris eu nibh euismod gravida.",
      customer_name: "Jane Smith"
    }
  ]);

  // useEffect(() => {
  //   try {
  //     async function getTestimonials() {
  //       const response = await get_all_testimonials();
  //       setTestimonials(response)
  //     }
  //     getTestimonials()
  //   }
  //   catch (error) {
  //     console.error("Error on Getting Testimonials")
  //   }
  // }, [])

  // console.log("Testimonials => ", testimonials)

  return (
    <>
      {testimonials.length > 0 && (
        <>
          <Box sx={{ paddingTop: { xs: 4, md: 6 }, backgroundColor: '#FFFFFF', textAlign: 'center' }}>
            <Typography sx={{
              fontWeight: "600 !important",
              color: "#cc0000 !important",
              textTransform: "uppercase",
              fontSize: {
                xs: "16px !important",
                sm: "24px !important",
                md: "32px !important",
              },
              mb: 1,
              fontFamily: 'playfair Display !important',
              letterSpacing: "1px !important",
            }}>What Our Customers Say</Typography>
            <Typography variant="h6"
              sx={{
                color: "#1A1A1A !important",
                fontSize: {
                  xs: "12px !important",
                  sm: "16px !important",
                  md: "18px !important",
                },
                fontFamily: "Inter, sans-serif !important",
                fontWeight: "400 !important",
                maxWidth: "600px",
                mx: "auto",
              }}
            >Real stories from food lovers who've enjoyed our hospitality</Typography>
          </Box>

          <Box
            sx={{
              maxWidth: '1440px',
              margin: { md: '0 auto' },
              height: { xs: '40vh', sm: '40vh', md: "350px" },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              mb: 2,
              backgroundColor: "#FFFFFF",
              position: "relative",
            }}
          >
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              loop={true}
              style={{
                width: "80%",
                height: "100%",
              }}
            >
              {testimonials.map((t, index) => (
                <SwiperSlide key={index}>
                  <Box sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    px: 2,
                  }}>
                    <Rating
                      name={`testimonial-rating-${index}`}
                      defaultValue={t.stars}
                      precision={0.5}
                      readOnly
                      sx={{
                        mb: 2,
                        "& .MuiSvgIcon-root": { fontSize: { xs: '15px !important', sm: '15px !important', md: "25px !important" } },
                        "& .MuiRating-iconEmpty": {
                          color: "transparent",
                          WebkitTextStroke: "2px #FFCF03",
                        },
                        "& .MuiRating-iconFilled": {
                          color: "#FFCF03",
                          WebkitTextStroke: "2px #FFCF03",
                        },
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: { xs: '15px !important', sm: '15px !important', md: "20px !important" },
                        color: "#cc0000",
                        mb: 2,
                        fontFamily: "Inter, sans-serif !important",
                        fontWeight: "500 !important",
                      }}
                    >
                      "{t.title}"
                    </Typography>
                    <Typography
                      sx={{
                        margin: "0 auto",
                        width: { xs: "90%", md: "50%" },
                        fontSize: { xs: '12px !important', sm: '12px !important', md: "16px !important" },
                        color: "#1A1A1A",
                        fontFamily: "Inter, sans-serif !important",
                        fontWeight: "400 !important",
                        lineHeight: "1.6 !important",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 3,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {t.description}
                    </Typography>
                    <Typography
                      sx={{
                        margin: "0 auto",
                        width: { xs: "90%", md: "50%" },
                        fontSize: { xs: '12px !important', sm: '12px !important', md: "16px !important" },
                        color: "#cc0000",
                        fontFamily: "Inter, sans-serif !important",
                        fontWeight: "600 !important",
                        mt: 2,
                      }}
                    >
                      - {t.customer_name}
                    </Typography>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Custom Navigation Buttons */}
            <IconButton
              className="swiper-button-prev"
              sx={{
                position: "absolute",
                left: { xs: 10, sm: 20, md: 50 },
                zIndex: 10,
                backgroundColor: "#cc0000",
                color: "white !important",
                width: { xs: 40, md: 50 },
                height: { xs: 40, md: 50 },
                "&:hover": {
                  backgroundColor: "#990000",
                },
                "&::after": {
                  display: "none",
                },
              }}
            >
              <ArrowBackIos sx={{ fontSize: { xs: 20, md: 24 }, color: "white !important" }} />
            </IconButton>

            <IconButton
              className="swiper-button-next"
              sx={{
                position: "absolute",
                right: { xs: 10, sm: 20, md: 50 },
                zIndex: 10,
                backgroundColor: "#cc0000",
                color: "white !important",
                width: { xs: 40, md: 50 },
                height: { xs: 40, md: 50 },
                "&:hover": {
                  backgroundColor: "#990000",
                },
                "&::after": {
                  display: "none",
                },
              }}
            >
              <ArrowForwardIos sx={{ fontSize: { xs: 20, md: 24 }, color: "white !important" }} />
            </IconButton>
          </Box>
        </>
      )}
    </>
  );
}
